import { render, staticRenderFns } from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=template&id=30c82a5d"
import script from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaOspiteDimissioneTrasferimentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports